import { render } from "./HomeView.vue?vue&type=template&id=164371a1&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=164371a1&scoped=true&lang=scss"

import exportComponent from "/Users/mosesadebayo/webprojects/askasoon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164371a1"]])

export default __exports__